import styled from 'styled-components';

export const MainContent = styled.div.attrs({ id: 'main-content' })`
  width: 100%;
  align-self: center;
  margin: 10px;
`;
